import { IHttpApi } from '@cian/http-api/shared';

import {
  fetchDeleteOfferFromFavorites,
  TDeleteOfferFromFavoritesRequest,
  TDeleteOfferFromFavoritesResponse,
} from '../../../repositories/favorites/v1/delete-offer-from-favorites';
import { assertUnknownError } from './assert';
import { IDeleteOfferFromFavorites } from '../../../types/favorite';

export async function deleteFavoriteRequest({
  httpApi,
  parameters,
}: {
  httpApi: IHttpApi;
  parameters: Omit<TDeleteOfferFromFavoritesRequest, 'dealType' | 'entityType'> &
    Partial<Pick<TDeleteOfferFromFavoritesRequest, 'dealType' | 'entityType'>>;
}): Promise<IDeleteOfferFromFavorites> {
  const response: TDeleteOfferFromFavoritesResponse = await fetchDeleteOfferFromFavorites({
    httpApi,
    parameters: {
      dealType: 'sale',
      entityType: 'offerResidental',
      ...parameters,
    },
  });

  assertUnknownError(response);

  return response.response;
}
